import {
  useState,
  Dispatch,
  useContext,
  createContext,
  SetStateAction,
} from "react";

interface IProps {
  children: JSX.Element;
}

interface ICreateContext {
  isBeta: boolean;
  setIsBeta: Dispatch<SetStateAction<boolean>>;
}

export const MoreContext = createContext<ICreateContext>({
  isBeta: false,
  setIsBeta: () => {},
});

/* eslint-disable react-refresh/only-export-components */
export default ({ children }: IProps) => {
  const [isBeta, setIsBeta] = useState<boolean>(false);

  return (
    <MoreContext.Provider
      value={{
        isBeta,
        setIsBeta,
      }}
    >
      {children}
    </MoreContext.Provider>
  );
};

export const useMore = () => {
  return useContext(MoreContext);
};
